<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0" v-if="isAuthorized">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <div class="text-h5">Analytics</div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="mt-0 pt-0">
                <!---Start: Aggregate cards---->
                <v-card flat class="py-0">
                  <v-card-text class="d-flex justify-start px-0 py-0">
                    <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                      <v-list-item>
                        <IconContainer size="50" imagePath="teamwork.png" />

                        <v-list-item-content class="ml-2">
                          <v-list-item-subtitle
                            >Total App Accounts
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6">{{
                            totalUsers
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>

                    <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                      <v-list-item>
                        <IconContainer
                          imagePath="pay-per-click.png"
                          size="50"
                          color="brightGreen"
                        />

                        <v-list-item-content class="ml-2">
                          <v-list-item-subtitle
                            >Active Subscriptions</v-list-item-subtitle
                          >
                          <v-list-item-title class="text-h6"
                            >{{ activeSubscriptions.length }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>

                    <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                      <v-list-item>
                        <IconContainer
                          imagePath="badge.png"
                          size="50"
                          color="purple"
                        />

                        <v-list-item-content class="ml-2">
                          <v-list-item-subtitle
                            >Active Cards</v-list-item-subtitle
                          >
                          <v-list-item-title class="text-h6">{{
                            activeBusinessCards.length
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>

                    <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                      <v-list-item>
                        <IconContainer
                          imagePath="goal.png"
                          size="50"
                          color="#FFB74D"
                        />

                        <v-list-item-content class="ml-2">
                          <v-list-item-subtitle
                            >Onboarding Pending</v-list-item-subtitle
                          >
                          <v-list-item-title class="text-h6">{{
                            onBoardingPending
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-card-text>
                </v-card>
                <!---End: Aggregate cards---->
              </v-col>
              <v-col cols="12" class="mt-0 pt-0">
                <!---Start: Aggregate cards---->
                <v-card flat class="py-0">
                  <v-card-text class="d-flex justify-start px-0 py-0">
                    <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                      <v-list-item>
                        <IconContainer size="50" imagePath="calendar.svg" />

                        <v-list-item-content class="ml-2">
                          <v-list-item-subtitle
                            >Monthly Subscription
                            <Tooltip
                              text="Total amount from active subscriptions on a monthly plan"
                              className="ml-1"
                            />
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6"
                            >{{ monthylSubscriptionAmount }}
                            <span class="text--secondary text-caption"
                              >/month</span
                            ></v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>

                    <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                      <v-list-item>
                        <IconContainer imagePath="planning.svg" size="50" />

                        <v-list-item-content class="ml-2">
                          <v-list-item-subtitle
                            >Annual Subscription
                            <Tooltip
                              text="Total amount from active subscriptions on a yearly plan"
                              className="ml-1"
                            />
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6"
                            >{{ annualSubscriptionAmount }}
                            <span class="text--secondary text-caption"
                              >/year</span
                            >
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>

                    <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                      <v-list-item>
                        <IconContainer imagePath="profit.svg" size="50" />

                        <v-list-item-content class="ml-2">
                          <v-list-item-subtitle
                            >Projected Revenue
                            <Tooltip
                              text="Pappyon's projected revenue"
                              className="ml-1"
                          /></v-list-item-subtitle>
                          <v-list-item-title class="text-h6">{{
                            totalRevenue
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>

                    <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                      <v-list-item>
                        <IconContainer imagePath="free.svg" size="50" />

                        <v-list-item-content class="ml-2">
                          <v-list-item-subtitle
                            >Trialing Subscriptions
                            <Tooltip
                              text="Number of subscriptions currently on free trial"
                              className="ml-1"
                          /></v-list-item-subtitle>
                          <v-list-item-title class="text-h6">{{
                            noOfTrialingSubscriptions
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-card-text>
                </v-card>
                <!---End: Aggregate cards---->
              </v-col>

              <v-col cols="3" class="flex-grow-1">
                <v-card outlined height="100%">
                  <v-card-title class="font-weight-regular"
                    >Subscriptions by Plan
                    <Tooltip
                      text="Breakup of active subscriptions by plan type"
                      className="ml-1"
                  /></v-card-title>
                  <v-card-text class="pa-0">
                    <div class="chart">
                      <DoughnutChart
                        ref="subscriptionByPlanChartRef"
                        :chart-data="subscriptionByPlanData"
                        :chart-options="doughtnutOptions"
                        chart-type="doughnut"
                        id="subscriptionByPlanChart"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3" class="flex-grow-1">
                <v-card outlined height="100%">
                  <v-card-title class="font-weight-regular"
                    >Active Cards by Type
                    <Tooltip
                      text="Breakup of active cards by plan type"
                      className="ml-1"
                  /></v-card-title>
                  <v-card-text class="pa-0">
                    <div class="chart">
                      <DoughnutChart
                        ref="activeBusinessCardsByTypeChartRef"
                        :chart-data="activeBusinessCardsByTypeData"
                        :chart-options="doughtnutOptions"
                        chart-type="doughnut"
                        id="activeBusinessCardsByTypeChart"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6" class="flex-grow-1">
                <v-card outlined height="100%">
                  <v-card-title class="font-weight-regular"
                    >Active App Accounts by Month</v-card-title
                  >
                  <v-card-text class="pa-0">
                    <LineChart />
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-tabs v-model="tab">
                  <v-tab class="text-capitalize">App Accounts</v-tab>
                  <v-tab class="text-capitalize">Business Profiles</v-tab>
                  <v-tab class="text-capitalize">Business Cards</v-tab>
                  <v-tab class="text-capitalize">Events</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item
                    ><Users
                      :cardholders="cardholders"
                      :businessPortalAccess="businessPortalAccess"
                      :allUsers="users"
                  /></v-tab-item>
                  <v-tab-item
                    ><BusinessProfiles
                      :businessPortalAccess="businessPortalAccess"
                      :cardholders="cardholders"
                      :users="users"
                      :businessProfiles="businessProfiles"
                  /></v-tab-item>
                  <v-tab-item
                    ><BusinessCards
                      :cardholders="cardholders"
                      :businessPortalAccess="businessPortalAccess"
                      :businessProfiles="businessProfiles"
                      :users="users"
                      :allMultiConnectEvents="allMultiConnectEvents"
                  /></v-tab-item>
                  <v-tab-item>
                    <v-row class="mt-3">
                      <v-col cols="4" md="3">
                        <MetricCard
                          title="Total Events"
                          :value="totalEvents"
                          image="meeting-room.svg"
                        />
                      </v-col>
                      <v-col cols="4" md="3">
                        <MetricCard
                          title="Total Registrants"
                          :value="totalRegistrants"
                          image="team-leader.svg"
                        />
                      </v-col>
                      <v-col cols="4" md="3">
                        <MetricCard
                          title="Total Connections"
                          :value="totalConnections"
                          image="social-media.svg"
                        />
                      </v-col>
                      <v-col cols="4" md="3">
                        <MetricCard
                          title="Active/Upcoming Events"
                          :value="totalActiveOrUpcomingEvents"
                          image="events.svg"
                        />
                      </v-col>
                    </v-row>

                    <MultiConnectTable
                      :multiConnectEvents="allMultiConnectEvents"
                      :isSuperUserDashboard="true"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <div class="text-h5">Forbidden</div>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Users from "@/components/SuperUser/Users";
import BusinessProfiles from "@/components/SuperUser/BusinessProfiles";
import BusinessCards from "@/components/SuperUser/BusinessCards";
import IconContainer from "@/components/IconContainer";
import DoughnutChart from "@/components/Charts/DoughnutChart";
import LineChart from "@/components/Charts/LineChart";
import * as currency from "currency.js";
import Tooltip from "@/components/Tooltip";
import MultiConnectTable from "@/components/MultiConnect/MultiConnectTable";
import { mapGetters, mapActions } from "vuex";
import MetricCard from "@/components/SuperUser/MetricCard";
import {onSnapshot, where} from "firebase/firestore";
import {
  getAuth,
  queryBusinessCardsCollection,
  queryBusinessPortalAccessCollection,
  queryUsersCollection
} from "@/shared/firebase_utils";

export default {
  components: {
    Users,
    BusinessProfiles,
    IconContainer,
    DoughnutChart,
    LineChart,
    BusinessCards,
    Tooltip,
    MultiConnectTable,
    MetricCard,
  },
  data() {
    return {
      tab: 0,
      unsubscribeCardholdersSnapshot: null,
      unsubscribeBusinessPortalAccessSnapshot: null,
      cardholders: [],
      businessPortalAccess: [],
      unsubscribeUsersSnapshot: null,
      users: [],
      doughnutData: {
        datasets: [
          {
            data: [10, 20, 30],
            backgroundColor: ["#80AEFF", "#FFD883", "#FFB6BD"],
          },
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        // labels: ["Trust", "Company", "SMSF's", "Unit Trust"],
      },
      doughtnutOptions: {
        legend: {
          display: true,
          maxWidth: 15,
          position: "bottom",
          labels: {
            usePointStyle: true,
          },
        },
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1.4,
        cutoutPercentage: 70,
      },
      chartData: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sept",
          "Oct",
          "Nov",
          "Dec",
        ],
        datasets: [
          {
            label: "This week",
            data: [12, 19, 25, 17, 23, 16, 18, 15, 20, 15, 20, 18],
            backgroundColor: "rgba(0, 0, 0, 0)",
            borderColor: "#002d80",
            lineTension: 0.3,
          },
        ],
      },
      chartOptions: {
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: { display: false },
            },
          ],
          yAxes: [
            {
              ticks: {
                stepSize: 1,
                callback: function (value, index, values) {
                  if (value % Math.round(values[0] / 6) == 0) {
                    return value;
                  } else if (value === 0) {
                    return value;
                  }
                },
              },
              // stacked: true
            },
          ],
        },
        maintainAspectRatio: true,
        legend: {
          display: false,
        },
        animation: {
          duration: 2000,
          easing: "easeInOutQuart",
        },
      },
      usersEmail: "",
      isAuthorized: false,
    };
  },
  created() {
    //Show the events tab if super user is reedirected to dashboard from Add / Edit MC Page
    let queryTab = this.$route.query.tab;

    if (queryTab != undefined) {
      this.tab = queryTab;
      this.$router.replace({ name: "Analytics" });
    }
    const auth = getAuth();
    this.usersEmail = auth.currentUser.email;

    if (
      this.usersEmail == "son@pappyon.com" ||
      this.usersEmail == "yash@pappyon.com"
    ) {
      this.isAuthorized = true;
      try {
        this.unsubscribeCardholdersSnapshot = onSnapshot(
              queryBusinessCardsCollection(),
              (response) => {
            const changes = response.docChanges();
            this.onCardholderSnapshot(changes);
          });
      } catch (error) {
        console.log(
          "Error occurred while fetching cardholders for super admin: ",
          error
        );
      }

      try {
        this.unsubscribeBusinessPortalAccessSnapshot = onSnapshot(
            queryBusinessPortalAccessCollection(where("businessName", ">", "")),
            (response) => {
            const changes = response.docChanges();
            this.onBusinessPortalAccessSnapshot(changes);
          });
      } catch (error) {
        console.log(
          "Error occurred while fetching business portal access for superadmin: ",
          error
        );
      }

      try {
        //Start: Snapshot for users
        this.unsubscribeUsersSnapshot = onSnapshot(
            queryUsersCollection(),
            (response) => {
            const changes = response.docChanges();
            this.onUsersSnapshot(changes);
          });

        //End: Snapshot for users
      } catch (error) {
        console.log(
          "Error occurred while fetching users for superadmin: ",
          error
        );
      }

      // //Start: Fetch user data from Cloud Function
      // const getUsers = firebase.functions().httpsCallable("getUsersFromAdmin");
      // let result = await getUsers({});
      // console.log("result: ", result);
    } else {
      this.isAuthorized = false;
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.$nextTick(() => {
        this.$refs.subscriptionByPlanChartRef.destroyChart();
        this.$refs.activeBusinessCardsByTypeChartRef.destroyChart();
        this.$refs.subscriptionByPlanChartRef.updateChart();
        this.$refs.activeBusinessCardsByTypeChartRef.updateChart();
      });
    });
  },
  computed: {
    ...mapGetters(["allMultiConnectEvents", "businessProfiles"]),
    totalUsers() {
      return this.users.length;
    },
    activeSubscriptions() {
      return this.businessProfiles.filter((businessProfile) => {
        return (
          businessProfile.subscriptionStatus == "active" ||
          businessProfile.subscriptionStatu == "trialing"
        );
      });
    },
    activeBusinessCards() {
      return this.cardholders.filter((cardholder) => {
        return cardholder.status.toLowerCase() == "active";
      });
    },
    onBoardingPending() {
      let onBoardingPending = this.users.filter((user) => {
        return !user.isOnBoardedOnApp;
      });
      return onBoardingPending.length;
    },
    subscriptionByPlanData() {
      let subscriptionByPlanData = {
        datasets: [
          {
            data: [
              this.activeSubscriptions.filter((subscription) => {
                return subscription.plan && subscription.plan == "evolve";
              }).length,
              this.activeSubscriptions.filter((subscription) => {
                return !subscription.plan || subscription.plan == "grow";
              }).length,
            ],
            backgroundColor: ["#80AEFF", "#FFD883"],
          },
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: ["Business + MC", "Business"],
      };
      return subscriptionByPlanData;
    },
    activeBusinessCardsByTypeData() {
      let activeBusinessCardsByTypeData = {
        datasets: [
          {
            data: [
              this.activeBusinessCards.filter((businessCard) => {
                return businessCard.subscriptionType == "HATCH";
              }).length,
              this.activeBusinessCards.filter((businessCard) => {
                return businessCard.subscriptionType != "HATCH";
              }).length,
            ],
            backgroundColor: ["#FFB6BD", "#FFD883"],
          },
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: ["Hatch", "Business"],
      };
      return activeBusinessCardsByTypeData;
    },
    monthylSubscriptionAmount() {
      let amount = 0;
      this.businessProfiles.forEach((businessProfile) => {
        if (
          businessProfile.subscriptionStatus == "active" &&
          businessProfile.billingPeriod == "monthly"
        ) {
          amount += businessProfile.nextInvoiceAmount;
        }
      });
      amount = currency(amount, { fromCents: true, separator: "," }).format();
      return amount;
    },
    annualSubscriptionAmount() {
      let amount = 0;
      this.businessProfiles.forEach((businessProfile) => {
        if (
          businessProfile.subscriptionStatus == "active" &&
          businessProfile.billingPeriod == "yearly"
        ) {
          amount += businessProfile.nextInvoiceAmount;
        }
      });
      amount = currency(amount, { fromCents: true, separator: "," }).format();
      return amount;
    },
    totalRevenue() {
      let amount = currency(this.monthylSubscriptionAmount)
        .multiply(12)
        .add(this.annualSubscriptionAmount)
        .format();

      return amount;
    },
    noOfTrialingSubscriptions() {
      return this.businessProfiles.filter((businessProfile) => {
        return businessProfile.subscriptionStatus == "trialing";
      }).length;
    },
    totalEvents() {
      return this.allMultiConnectEvents?.length || 0;
    },
    totalRegistrants() {
      let totalRegistrants = 0;
      this.allMultiConnectEvents.forEach((event) => {
        totalRegistrants += event.attendees?.length || 0;
      });
      return totalRegistrants;
    },
    totalConnections() {
      let totalConnections = 0;
      this.allMultiConnectEvents.forEach((event) => {
        if (event.noOfConnections != undefined)
          totalConnections += event.noOfConnections;
      });
      return totalConnections;
    },
    totalActiveOrUpcomingEvents() {
      let totalActiveOrUpcomingEvents = 0;
      this.allMultiConnectEvents.forEach((event) => {
        if (event.getStatus() != "Past") {
          totalActiveOrUpcomingEvents++;
        }
      });
      return totalActiveOrUpcomingEvents;
    },
  },
  destroyed() {
    this.unsubscribeCardholdersSnapshot();
    this.unsubscribeBusinessPortalAccessSnapshot();
    this.unsubscribeUsersSnapshot();
  },
  methods: {
    onCardholderSnapshot(changes) {
      changes.forEach((change) => {
        let data = change.doc.data();
        if (change.type === "added") {
          this.cardholders.push({
            ...change.doc.data(),
            id: change.doc.id,
          });
        } else if (change.type == "modified") {
          //Replace the old cardholder object within the cardholder array with the modified object
          this.cardholders.forEach((cardholder, i) => {
            if (cardholder.id == change.doc.id) {
              //Remove the old object of the modified cardholder
              this.cardholders.splice(i, 1);
              //Add the modified cardholder
              this.cardholders.push({
                ...data,
                id: change.doc.id,
              });
            }
          });
        } else if (change.type == "removed") {
          //Remove the cardholder object from the cardholder array
          this.cardholders.forEach((cardholder, i) => {
            if (cardholder.id == change.doc.id) {
              //Remove the object of the removed cardholder
              this.cardholders.splice(i, 1);
            }
          });
        }
      });
    },
    onBusinessPortalAccessSnapshot(changes) {
      changes.forEach((change) => {
        let data = change.doc.data();
        if (change.type === "added") {
          this.businessPortalAccess.push({
            ...data,
          });
        } else if (change.type == "modified") {
          //Replace the old cardholder object within the cardholder array with the modified object
          this.businessPortalAccess.forEach((item, i) => {
            if (item.businessProfileId == data.businessProfileId) {
              //Remove the old object of the modified cardholder
              this.businessPortalAccess.splice(i, 1);
              //Add the modified cardholder
              this.businessPortalAccess.push({
                ...data,
              });
            }
          });
        } else if (change.type == "removed") {
          //Remove the cardholder object from the cardholder array
          this.businessPortalAccess.forEach((item, i) => {
            if (item.businessProfileId == data.businessProfileId) {
              //Remove the object of the removed cardholder
              this.businessPortalAccess.splice(i, 1);
            }
          });
        }
      });
    },
    onUsersSnapshot(changes) {
      changes.forEach((change) => {
        let data = change.doc.data();
        if (change.type === "added") {
          let platforms = [];
          if (data.hasLoggedInToAndroid) platforms.push("Android");
          if (data.hasLoggedInToIos) platforms.push("iOS");
          if (data.hasLoggedInToWeb) platforms.push("Web");
          if (data.hasLoggedInToBusinessPortal)
            platforms.push("Business Portal");
          this.users.push({
            ...change.doc.data(),
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            displayImageUrl: data.displayImageUrl,
            isOnBoardedOnApp: data.isOnBoardedOnApp,
            id: change.doc.id,
            lastLoginDate: data.lastLoginDate || "",
            lastLoggedInPlatform: data.lastLoggedInPlatform || "",
            hasLoggedInToAndroid: data.hasLoggedInToAndroid || false,
            hasLoggedInToIos: data.hasLoggedInToIos || false,
            hasLoggedInToWeb: data.hasLoggedInToWeb || false,
            hasLoggedInToBusinessPortal:
              data.hasLoggedInToBusinessPortal || false,
            signupType: data.signupType || "",
            platforms: platforms,
          });
        } else if (change.type == "modified") {
          //Replace the old cardholder object within the cardholder array with the modified object
          this.users.forEach((user, i) => {
            if (user.email == data.email) {
              //Remove the old object of the modified cardholder
              this.users.splice(i, 1);

              //Store platforms
              let platforms = [];
              if (data.hasLoggedInToAndroid) platforms.push("Android");
              if (data.hasLoggedInToIos) platforms.push("iOS");
              if (data.hasLoggedInToWeb) platforms.push("Web");
              if (data.hasLoggedInToBusinessPortal)
                platforms.push("Business Portal");
              //Add the modified cardholder
              this.users.push({
                ...data,
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                displayImageUrl: data.displayImageUrl,
                isOnBoardedOnApp: data.isOnBoardedOnApp,
                id: change.doc.id,
                lastLoginDate: data.lastLoginDate || "",
                lastLoggedInPlatform: data.lastLoggedInPlatform || "",
                hasLoggedInToAndroid: data.hasLoggedInToAndroid || false,
                hasLoggedInToIos: data.hasLoggedInToIos || false,
                hasLoggedInToWeb: data.hasLoggedInToWeb || false,
                hasLoggedInToBusinessPortal:
                  data.hasLoggedInToBusinessPortal || false,
                signupType: data.signupType || "",
                platforms: platforms,
              });
            }
          });
        } else if (change.type == "removed") {
          //Remove the cardholder object from the cardholder array
          this.users.forEach((user, i) => {
            if (user.email == data.email) {
              //Remove the object of the removed cardholder
              this.users.splice(i, 1);
            }
          });
        }
      });
    },
  },
};
</script>

<style>
.chart {
  width: 100%;
  height: auto;
  min-height: 200px;
}
</style>
